import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

/**
 * Hook to check if the seller's trial is currently active
 * Returns true if the trial end date is in the future, false otherwise
 * @returns {boolean} Whether the trial is currently active
 */
export const useIsTrialActive = () => {
  const subscriptionPlanInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);

  if (!subscriptionPlanInfo || !subscriptionPlanInfo.trialEndDate) {
    return false;
  }

  const trialEndDate = new Date(subscriptionPlanInfo.trialEndDate);
  if (Number.isNaN(trialEndDate.getTime())) {
    return false;
  }

  const currentDate = new Date();
  return trialEndDate > currentDate;
};
